export default function IconAlert() {
  return (
    <svg
      id="icon_alert"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24.696"
      viewBox="0 0 24 24.696"
    >
      <path
        id="Caminho_4309"
        data-name="Caminho 4309"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Caminho_4310"
        data-name="Caminho 4310"
        d="M4,20V14a8,8,0,0,1,16,0v6h1v2H3V20Zm2,0H18V14A6,6,0,0,0,6,14Zm4.8,1.134h2s.5,2.25,0,3a1.17,1.17,0,0,1-2,0C10.3,23.384,10.8,21.134,10.8,21.134ZM7,14a5,5,0,0,1,5-5v2a3,3,0,0,0-3,3Z"
        fill="#c45151"
      />
    </svg>
  );
}
